// Production configurations
export const API_URL = 'https://lmprx-prod-api.bob-prod-01.ew2.purple-rain.net/v2';
export const DASHBOARD_URL = 'https://app.limeproxies.com';

// Development configurations
export const API_DEV_URL = 'http://dev.api.limeproxies.com/v2';
// export const API_DEV_URL = 'http://localhost:10000/v2';
export const DASHBOARD_DEV_URL = 'http://dev.dashboard.limeproxies.com';

// Stage configurations
export const API_STAGE_URL = 'http://stage.api.limeproxies.com/v2';
export const DASHBOARD_STAGE_URL = 'http://stage.dashboard.limeproxies.com';

export const RECORDS_PER_PAGE = 10;

export const READY_ONLY = false;

export const READY_ONLY_WHITELIST = ['admin/login'];